import React from "react";
import {
  PageWrapper,
  FooterLogoImage,
  LoginBlock,
  Logo,
  Footer,
  CopyRightText,
  LoginContent,
  MaintenanceLogo,
  FlashHireLogo,
  MaintenanceTitle,
  MaintenanceDescription,
  FlashHireLogoContainer,
} from "./styledComponents";

function MaintenancePage() {
  return (
    <div style={styles.body}>
      <div style={styles.container}>
        <FlashHireLogo src="/img/flash-hire.png" alt="Flash Hire" />

        <div style={styles.message}>Temporarily Down for Maintenance</div>
        <div style={styles.subMessage}>
          We are performing scheduled maintenance. We should be back online
          shortly
        </div>
        <div style={styles.footer}>
          Copyright © 2021 TDCX. All Rights Reserved.
        </div>
      </div>
    </div>
  );
}

const styles = {
  body: {
    fontFamily: "Arial, sans-serif",
    backgroundColor: "#f5f5f5",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    height: "100vh",
    margin: 0,
  },
  container: {
    textAlign: "center",
    background: "white",
    padding: "40px",
    borderRadius: "10px",
    boxShadow: "0 4px 10px rgba(0, 0, 0, 0.1)",
  },
  message: {
    fontSize: "20px",
    fontWeight: "bold",
    color: "#333",
  },
  subMessage: {
    color: "#666",
    marginTop: "10px",
  },
  footer: {
    marginTop: "30px",
    fontSize: "12px",
    color: "#999",
  },
};

export default MaintenancePage;
